<div class="container pt-3">
  <div class="row">
    <section class="projects">
      <div class="row">
        <div class="col-12 text-center pb-3">
          <h1 class="header">{{ "Our Projects" | translate }}</h1>
        </div>
        <div class="col-12 pb-4">
          <div class="row">
            <div class="col-2 logo-class" *ngFor="let logo of logos">
              <img src="{{ logo }}" width="100%" height="100%" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="col-12">
      <div class="row">
        <header class="col-12 text-center mt-5 mb-5">
          <h2 class="header">{{ "Happy Customer" | translate }}</h2>
          <carousel>
            <slide *ngFor="let item of carousel">
              <img
                src="{{ item }}"
                alt="first slide"
                style="display: block; width: 100%;"
              />
            </slide>
          </carousel>
        </header>
      </div>
    </section>
  </div>
</div>
